import React from 'react';
import SafeImage from '../../../../../../elements/SafeImage';
import {calculateBarSize} from '../../calculateBarSize';
import stylesheet from '../PictoGraph.module.scss';

const Result = props => {
    const {option, value, sum, max, pictogram} = props,
        size = calculateBarSize(sum, value, max);

    return (
        <div className={stylesheet.option}>
            <div className={stylesheet.pictoContainer}>
                <img
                    src={pictogram}
                    style={{
                        height: `${size * 100}%`,
                    }}
                />
            </div>
            <div className={stylesheet.value}>{Math.round((value / sum) * 1000) / 10}%</div>
            <div className={stylesheet.label}>{option.label}</div>
        </div>
    );
};

export default Result;
